export default __webpack_public_path__ + "static/media/christmas-challenge-prize.34425354.png";